"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessData = businessData;
exports.chartBuyApi = chartBuyApi;
exports.chartOrder30Api = chartOrder30Api;
exports.chartOrderMonthApi = chartOrderMonthApi;
exports.chartOrderWeekApi = chartOrderWeekApi;
exports.chartOrderYearApi = chartOrderYearApi;
exports.chartUserApi = chartUserApi;
exports.userChannelData = userChannelData;
exports.viewModelApi = viewModelApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 首页数据概览
function viewModelApi() {
  return (0, _request.default)({
    url: '/admin/platform/statistics/home/index',
    method: 'GET'
  });
}

// 用户曲线图
function chartUserApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user',
    method: 'get'
  });
}

// 用户购买统计
function chartBuyApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user/buy',
    method: 'get'
  });
}

// 订单量趋势 30天
function chartOrder30Api() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order',
    method: 'get'
  });
}

// 订单量趋势 月
function chartOrderMonthApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/month',
    method: 'get'
  });
}

// 订单量趋势 周
function chartOrderWeekApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/week',
    method: 'get'
  });
}

// 订单量趋势 年
function chartOrderYearApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/year',
    method: 'get'
  });
}

// 首页经营数据
function businessData() {
  return (0, _request.default)({
    url: '/admin/platform/statistics/home/operating/data',
    method: 'get'
  });
}

/**
 * 用户渠道数据
 * @param pram
 */
function userChannelData() {
  return (0, _request.default)({
    url: "/admin/platform/statistics/home/channel",
    method: 'GET'
  });
}